import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Icon } from '@cld/icon';
import { onHover } from './draggable.helpers';

const Handle = styled.div`
  cursor: grabbing;
  margin: 0 ${globalTheme.spacing.xs};
  display: flex;
`;

const Preview = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const DraggableWithHandle = ({ id, index, onMove, onDrop, className, iconSize = 'sm', type, children }) => {
  const ref = useRef(null);
  const [{ isDragging }, drag, preview] = useDrag({
    item: { type, id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: type,
    hover(item, monitor) {
      onHover(item, monitor, index, ref, onMove);
    },
    drop({ id, index }) {
      // Commit the change (probably to server)
      onDrop && onDrop(id, index);
    },
  });
  const opacity = isDragging ? 0 : 1;
  drop(ref);

  return (
    <div ref={ref} className={className} style={{ opacity }} data-test="draggable-with-handle">
      <Preview ref={preview}>
        <Handle ref={drag} data-test="handle">
          <Icon name="draggable" size={iconSize} />
        </Handle>
        {children}
      </Preview>
    </div>
  );
};
